import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { Conditions, getConditionsFilterConfig } from '../filters/condition';
import { getColorFilterConfig } from '../filters/color';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { BuilderSections } from '../../util/builder';

const leathermanConditionOptions = [
  {
    key: Conditions.NewWithTags,
    label: 'New In Box',
    description: 'Tool, literature and any included accessories are in the original box.',
  },
  {
    key: Conditions.NewWithoutTags,
    label: 'New Without Packaging',
    description:
      'Just the tool, but it does not show signs of use. List any accessories included with your listing.',
  },
  {
    key: Conditions.Excellent,
    label: 'Used In Excellent Condition',
    description:
      'Tool shows signs of use, but no wear & tear, no cosmetic issues, no missing bits or attachments. List any accessories included with your listing.',
  },
  {
    key: Conditions.Good,
    label: 'Used In Good Condition',
    description:
      'Tool shows signs of use, and has some light scratches or scuffs, may be missing a bit or attachment. List any accessories included with your listing.',
  },
];

export const leathermanShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig({ options: leathermanConditionOptions }),
    getColorFilterConfig(),
    getBrandDirectFilterConfig(),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.TopbarContent]: '799bb0fc34ef43288183389e3dac46d7',
    },
  },
};
